export const EvaluationType = {
  LENDING: "lending",
  COLLATERAL: "collateral",
};
